import checkIcon from '@/assets/toast/check.svg';

const RING_OUTER =
  'flex size-[100px] shrink-0 items-center justify-center rounded-full bg-success/5 shadow-halo-success';
const RING_INNER =
  'relative flex size-[60px] shrink-0 items-center justify-center overflow-visible rounded-full border-[10px] border-solid border-success/10 bg-white';

export interface SuccessToastMarkProps {
  className?: string;
}

/** Same stacked rings + check asset as success toasts (`ToastHost`). */
export function SuccessToastMark({ className = '' }: SuccessToastMarkProps) {
  return (
    <div className={`${RING_OUTER} ${className}`.trim()} aria-hidden>
      <div className={RING_INNER}>
        <img src={checkIcon} alt="" className="absolute size-[60px] max-w-none" />
      </div>
    </div>
  );
}
